import { Button, Campaign, Checkout, Prizes, Ranking } from '@hub/shared'
import { useTranslation } from 'react-i18next'
import { Navigate, useNavigate } from 'react-router'
import ItemToCheckoutComponent from './components/item-to-checkout/item-to-checkout.component'
import './prizes.page.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  userRanking: Ranking
  prizes: Prizes[]
  campaign: Campaign
  checkouts: Checkout[]
  onConfirmCheckout: () => void
  pathname: string
}

export default ({ userRanking, prizes = [], campaign, checkouts = [], onConfirmCheckout, pathname }: Props) => {
  const [t] = useTranslation('engage')
  const navigate = useNavigate()

  const toCheckoutPage = () => {
    navigate(window.location.href?.replace('prizes', 'checkouts'))
  }

  if (!prizes?.length) {
    return <Navigate to={`${pathname?.replace('prizes', 'pointing')}`} />
  }

  return (
    <div className="engage-prizes-page">
      <div className="text-center">
        <div className="balance">
          <h5>{t('prizesPage.balance')}</h5>
          <h2>{userRanking?.totalAvailable || 0}</h2>
          <p
            className="text-left"
            dangerouslySetInnerHTML={{
              __html: t('prizesPage.textBalance', { number: userRanking?.total - userRanking?.totalAvailable || 0 }),
            }}
          />
        </div>
      </div>
      <hr />
      <h5>{t('prizesPage.title')}</h5>
      <ul className="prizes">
        {prizes?.map((prize) => (
          <li key={prize?.id}>
            <ItemToCheckoutComponent
              onConfirmCheckout={onConfirmCheckout}
              campaign={campaign}
              checkouts={checkouts}
              prize={prize}
              userRanking={userRanking}
            />
          </li>
        ))}
      </ul>
      <hr />
      <h5>{t('prizesPage.checkout.title')}</h5>
      <p className="mb-3">{t('prizesPage.checkout.subtitle')}</p>
      <Button width="100%" onClick={() => toCheckoutPage()}>
        {t('prizesPage.checkout.button')}
      </Button>
    </div>
  )
}
